"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlurryAbilityHandler = exports.FlurryActorAbilityFactory = exports.FlurryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class FlurryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Flurry;
        this.__typeName = "Flurry";
    }
}
exports.FlurryAbilityArgs = FlurryAbilityArgs;
let FlurryActorAbilityFactory = class FlurryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Flurry", "AllEnemies", 2);
    }
};
FlurryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Flurry")
], FlurryActorAbilityFactory);
exports.FlurryActorAbilityFactory = FlurryActorAbilityFactory;
let FlurryAbilityHandler = class FlurryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(enemyId => ({
                targetId: enemyId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ],
            })),
            onHit(sequence) {
                container.applyBuff({
                    sequence: sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Power"))
                });
            },
        });
    }
};
FlurryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Flurry)
], FlurryAbilityHandler);
exports.FlurryAbilityHandler = FlurryAbilityHandler;
